namespace GeniuzPOS.Purchase {
    export interface PoPayTermCodeRow {
        Id?: number;
        PayTermCode?: string;
        PayTermDesc?: string;
        CreditTerm?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        LookupName?: string;
    }

    export namespace PoPayTermCodeRow {
        export const idProperty = 'PayTermCode';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Purchase.PoPayTermCode';
        export const lookupKey = 'Purchase.PoPayTermCode';

        export function getLookup(): Q.Lookup<PoPayTermCodeRow> {
            return Q.getLookup<PoPayTermCodeRow>('Purchase.PoPayTermCode');
        }
        export const deletePermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';
        export const insertPermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';
        export const readPermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:View';
        export const updatePermission = '5Purchase:ข้อมูลอ้างอิงระบบซื้อ:Modify';

        export declare const enum Fields {
            Id = "Id",
            PayTermCode = "PayTermCode",
            PayTermDesc = "PayTermDesc",
            CreditTerm = "CreditTerm",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            LookupName = "LookupName"
        }
    }
}
